<template>
    <v-card class="text-center" flat tile>
      <span v-html="infoTextura" />
    </v-card>
  </template>
  
  <script>
  import { mapState } from "vuex";
  export default {
    computed: {
      ...mapState(["EspecifTecnica"]),
      infoTextura() {
        const info = this.EspecifTecnica.filter(f => f.Descripcion === "TEXTURA")[0]
        if (info) {
          const { Valor } = info
          return Valor
        }
        else return "--"
      }
    },
  };
  </script>
  
  <style></style>